import React, { useContext, useState } from "react";
import ModalWithCloseButton from "../../../components/modal/ModalWithCloseButton";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import RegisterContext from "../../../context/RegisterContext";
import { useNavigate } from "react-router-dom";
import {
  useConfirmPayment,
  useDeleteRecord,
  useRegisterCustomer,
} from "../../../hooks/api/post";
import { closePaymentModal } from "flutterwave-react-v3";
import { useFlutterwave } from "./useFlutterwave";
import { useRemitaPayment } from "./useRemita";
import Swal from "sweetalert2";
import { FlutterWaveResponse } from "flutterwave-react-v3/dist/types";
import { OnboardingResponse, RemittaResponse } from "./types/payment";
// import useFlutterWave from "../../../hooks/api/useFlutterWave";

interface FlutterWaveResponse2 extends FlutterWaveResponse {
  charge_response_message: string;
}
function Payment({ open, handleClose }: { open: boolean; handleClose?: any }) {
  const deleteRecord = useDeleteRecord();

  const navigate = useNavigate();
  const registerAPI = useRegisterCustomer();

  const { state, dispatch } = useContext(
    RegisterContext
  ) as IRegisterContextProps;

  const confirmPayment = useConfirmPayment();
  const flutterWave = useFlutterwave({
    live: process.env.NODE_ENV === "production" ? true : false,
  });
  const remita = useRemitaPayment({
    live: false,
    // live: process.env.NODE_ENV === "production" ? true : false,
  });
  const handlePaymentSubmit = (e: any | React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    let paymentType = e.nativeEvent.submitter.name;
    if (paymentType === "transfer") {
      dispatch((prev: any) => ({
        ...prev,
        accountDetails: true,
        payment: false,
      }));
    } else {
      dispatch((prev: any) => ({
        ...prev,
        accountDetails: false,
        payment: false,
        openSpinner: true,
      }));
      handleRegisterCustomer(paymentType);
      // navigate("https://flutterwave.com");
    }
  };

  function handleRegisterCustomer(paymentType: string) {
    registerAPI.mutate(
      {
        ...state.values,
        paymentSource: paymentType === "flutterwave" ? 3 : 4,
      },
      {
        onSuccess: (res: OnboardingResponse) => {
          if (paymentType === "flutterwave") {
            flutterWave.startPayment({
              public_key: process.env.REACT_APP_FLW_PUBLIC_KEY,
              tx_ref: res.result.paymentId,
              amount: Number(state.values?.amount),
              currency: "NGN",
              payment_options: "card,mobilemoney,ussd",
              customer: {
                email: state?.values?.email,
                phone_number: state?.values?.mobile,
                name: state?.values?.firstName,
              },
              subaccounts: [
                {
                  id:
                    state.values?.productType === "2"
                      ? "RS_4D50C993C13FDD2A63A06F7565C1AAA1" //LDF Flutterwave account ID
                      : state.values?.productType === "3"
                      ? "RS_2212FB0FF68D8619AA82E41C3B2F760E " //LEF
                      : "RS_2390A7B7681B01BC9FCE4EA7EF310F5A ", //LMMF
                },
              ],
              customizations: {
                title: "FCMB Asset Management",
                description: "Payment",
                // logo: "https://st2.depositphotos.com/4403291/7418/v/450/depositphotos_74189661-stock-illustration-online-shop-log.jpg",
              },
              callback: (flutterwaveResponse: FlutterWaveResponse2) => {
                //
                console.log({ flutterwaveResponse });
                if (
                  flutterwaveResponse.status === "successful" ||
                  flutterwaveResponse.charge_response_message ===
                    "Approved Successful"
                ) {
                  dispatch((prev: any) => ({ ...prev, openSpinner: true }));
                  confirmPayment.mutate(
                    {
                      amountPaid: Number(state.values?.amount),
                      paymentProcessorsReference: `${flutterwaveResponse.transaction_id}`,
                      paymentSource: 3,
                      transactionReference: res.result.paymentId,
                    },
                    {
                      onSuccess: () => {
                        navigate("/register/successful-registration");
                      },
                    }
                  );
                } else {
                  toast.dismiss();
                  toast.error("Payment Failed. Please try again later.");
                  deleteRecord.mutate({
                    email: state.values?.email as string,
                    productSubscriptionFundType: Number(
                      state.values?.productType
                    ) as 1 | 2 | 3 | 4,
                  });
                }
                closePaymentModal();
              },
              onclose: () => {
                toast.dismiss();
                toast.warn("Payment was cancelled");
                deleteRecord.mutate({
                  email: state.values?.email as string,
                  productSubscriptionFundType: Number(
                    state.values?.productType
                  ) as 1 | 2 | 3 | 4,
                });
              },
            });
          } else {
            remita.startPayment({
              key: process.env.REACT_APP_REMITA_PUBLIC_KEY, // enter your key here
              processRrr: true,
              narration: `Payment for FCMBAM Mutual Funds product`,
              transactionId: res.result.paymentId,
              extendedData: {
                // Optional field. Details are available in the table
                customFields: [
                  {
                    name: "rrr",
                    value: res.result.remittaReference,
                  },
                ],
              },
              onSuccess: (remittaResponse: RemittaResponse) => {
                dispatch((prev: any) => ({ ...prev, openSpinner: true }));
                confirmPayment.mutate(
                  {
                    amountPaid: Number(state.values?.amount),
                    paymentProcessorsReference:
                      remittaResponse.paymentReference,
                    paymentSource: 4,
                    transactionReference: res.result.paymentId,
                  },
                  {
                    onSuccess: (confirmPaymentResponse) => {
                      navigate("/register/successful-registration");
                    },
                    onError: () => {
                      toast.dismiss();
                      toast.error(
                        "An error occurred while confirming your payment. Kindly reach out to fcmbamsd@fcmb.com"
                      );
                    },
                  }
                );

                //
              },
              onError: () => {
                toast.dismiss();
                toast.error("Payment failed");
                deleteRecord.mutate({
                  email: state.values?.email as string,
                  productSubscriptionFundType: Number(
                    state.values?.productType
                  ) as 1 | 2 | 3 | 4,
                });
              },
              onClose: function () {
                toast.dismiss();
                // toast.warn("Payment was cancelled");

                // function callback when payment modal is closed
                //
              },
            });
          }
        },
        onError: (err: any) => {
          if (err.response.status === 400) {
            Swal.fire({
              title:
                err.response?.data?.errorMessages?.[0]?.type ||
                "Account already exists",
              text:
                err.response?.data?.errorMessages?.[0]?.message ||
                "Sorry! You already onboarded for this product already",
              icon: "error",
              confirmButtonText: "Continue",
            });
          } else {
            toast.dismiss();
            toast.error(err.message);
          }
        },
        onSettled: (set) => {
          dispatch((prev: any) => ({
            ...prev,
            accountDetails: false,
            payment: false,
            openSpinner: false,
          }));
        },
      }
    );
  }

  return (
    <ModalWithCloseButton open={open} handleClose={handleClose}>
      {/* // handleClose={() => setOpenModal(false)}> */}
      <Box p={2}>
        <Typography variant="h5">
          {" "}
          Choose / Select preferred payment method
        </Typography>
        <Box mt={0.5} mb={1.5}>
          <Divider />
        </Box>
        <form onSubmit={handlePaymentSubmit}>
          <FormGroup>
            <FormControlLabel
              required
              control={<Checkbox />}
              label="I have read the terms and conditions"
            />
            <Typography variant="body2">
              {" "}
              Click{" "}
              <a
                href="./termsandconditions.pdf"
                download={"Term and Conditions.pdf"}
              >
                here
              </a>{" "}
              to read the terms and conditions
            </Typography>
            <Grid
              xs={12}
              container
              mt={3}
              mb={2}
              px={{ xs: 2.5, md: 0 }}
              justifyContent={"space-around"}
            >
              <Grid
                item
                xs={12}
                md={3.6}
                alignItems={"center"}
                // sx={{ border: "1px solid red" }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    fullWidth
                    type="submit"
                    variant="contained"
                    startIcon={<AccountBalanceIcon />}
                    name="transfer"
                  >
                    {" "}
                    Pay Via Bank Transfer
                  </Button>
                </Box>
              </Grid>
              {state.values?.productType !== "4" && (
                <Grid
                  item
                  xs={12}
                  md={7.6}
                  // px={{ xs: 1.5, md: 0 }}
                  mt={{ xs: 2.5, md: 0 }}
                >
                  <Grid container justifyContent="space-between">
                    <Grid item xs={12} md={5.8}>
                      <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        startIcon={<CreditCardIcon />}
                        name="flutterwave"
                      >
                        {" "}
                        Pay Via (Flutterwave)
                      </Button>
                    </Grid>
                    <Grid item xs={12} md={5.8} mt={{ xs: 3, md: 0 }}>
                      <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        startIcon={<CreditCardIcon />}
                        name="remitta"
                        disabled
                      >
                        {" "}
                        Pay Via Card (Remitta)
                      </Button>
                    </Grid>
                  </Grid>

                  <Box p={1} mt={1} sx={{ border: "1px solid secondary" }}>
                    <Typography variant="body2" fontSize={10}>
                      {" "}
                      Please note that a flat transaction fee of N350 applies on
                      "pay via card", and the payment will reflect the next day.
                    </Typography>
                  </Box>
                </Grid>
              )}
            </Grid>
          </FormGroup>
        </form>
        {/* <Remita /> */}
        {/* <Flutterwave /> */}
      </Box>
    </ModalWithCloseButton>
  );
}

export default Payment;
